import {OneServiceApiProviderConfiguration} from '../oneservice-api';

export const DefaultOneServiceApiProviderConfiguration: OneServiceApiProviderConfiguration = {
    url: process.env.ONESERVICE_API_URL,
    apiKey: process.env.ONESERVICE_API_KEY,
};
